import { TrackLinkDirective } from '@analytics/events';
import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { EcmpAffiliateLogo } from '@core/navigation-store';
import { MediaObserverService } from '@innogy/shared/responsive-tools';

@Component({
  selector: 'wl-navigation-ecmp-logo',
  standalone: true,
  imports: [NgClass, TrackLinkDirective],
  templateUrl: './navigation-ecmp-logo.component.html',
  styleUrls: [
    './navigation-ecmp-logo.component.ed.scss',
    './navigation-ecmp-logo.component.essent.scss',
  ],
})
export class NavigationEcmpLogoComponent {
  readonly deviceInfo = inject(MediaObserverService).deviceInfo;

  readonly logo = input.required<EcmpAffiliateLogo>();
  /** A dividing line left of the logo (so it can be placed nex to another logo */
  readonly withLeftDivider = input(true);

  readonly deviceInfoMatchesLogo = computed(
    () =>
      (this.deviceInfo().isDesktop && this.logo().showOnDesktop) ||
      (this.deviceInfo().isTablet && this.logo().showOnTablet) ||
      (this.deviceInfo().isMobile && this.logo().showOnMobile)
  );
}
